import '@babel/polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import routes from './routes'
import { Router, Switch, Redirect } from 'react-router-dom'
import { RouteWithSubRoutes } from './routes/RouteWithSubRoutes'
import tools from './utils/tools'
import store, { history } from './store'
import { Provider } from 'react-redux'
// import './utils/vconsole'

import './index.less'
import '@assets/css/iconfont.css'
import '@assets/iconfont/iconfont.css';
import * as serviceWorker from './serviceWorker'

import http from './utils/http'

global.http = http
global.isWeiXin = tools.isWeiXin()

//启动画面在components/Loading/Home/style.less 中
const RouterConfig = () => (
      <Provider store={store}>
            <Router history={history}>
                  <Switch>
                        {routes.map((route, i) => (
                              <RouteWithSubRoutes key={i} {...route} />
                        ))}
                        <Redirect from="/" to="/home" />
                  </Switch>
            </Router>
      </Provider>
)


ReactDOM.render(<RouterConfig />, document.getElementById('root'))

serviceWorker.register()
